// import React from 'react';

import './Elements.scss';
import Atoms from './Atoms';
import Molecules from './Molecules';

let Elements = {
    Atoms,
    Molecules
};
// const Elements = () => {
//     return (
//         <React.Fragment>
            
//         </React.Fragment>
//     );
// }

export default Elements;